import { zodSortField } from "@/lib/utils";
import { z } from "zod";
import { functionality } from "@/prisma/generated/enums";

export const deleteRestrictedCathrinUserSchema = z.object({
  id: z.number(),
});

export const getRestrictedCathrinUsersRequestSchema = z.object({
  sort: zodSortField(["user"]),
});

export const addRestrictedCathrinUserSchema = z.object({
  user: z
    .string()
    .min(1, "L'identifiant utilisateur est requis")
    .max(20, "Maximum de caractères atteint"),
  functionality: z.nativeEnum(functionality, {
    errorMap: () => ({
      message: "La fonctionnalité est requise",
    }),
  }),
});

export const editRestrictedCathrinUserSchema = z.object({
  id: z.number().optional(),
  user: z
    .string()
    .min(1, "L'identifiant utilisateur est requis")
    .max(20, "Maximum de caractères atteint"),
  functionality: z.nativeEnum(functionality, {
    errorMap: () => ({
      message: "La fonctionnalité est requise",
    }),
  }),
  isActive: z.boolean().default(true),
});
